var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { size } from 'polished';
import { display, alignItems, position, top, space, justifyContent, backgroundColor, boxShadow, fontSize, width, border, height, } from 'styled-system';
import { boxSizing, themeHeight, themeLeft, themeWidth, } from '../../common/theme/system-utilities';
import { EventBusEvent } from '../../common/enums/EventBus';
import { useCloseDrawer } from '../../common/hooks/drawer';
import Drawer, { DRAWER_WIDTH } from '../../common/components/Drawer';
import RichTextBlock from '../../common/components/RichText';
import Icon from '../../common/components/Icon';
import SwipeListener from '../../common/components/SwipeListener';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import { useLocalization } from '../../common/providers/LocaleProvider';
var ICON_SIZE = 24;
var Header = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n  z-index: 2;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n  z-index: 2;\n"])), display, alignItems, position, top, space, fontSize, themeHeight, themeWidth, width, justifyContent, backgroundColor, boxShadow, border);
Header.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    px: ['sp_12', 'sp_20', null, 'sp_24'],
    py: 0,
    fontSize: ['fs_16', null, null, 'fs_18'],
    themeHeight: ['54px', 'sp_64'],
    width: 1,
    justifyContent: 'center',
    backgroundColor: 'white',
    boxShadow: 'bottom',
    border: 'none',
    themeWidth: DRAWER_WIDTH,
};
var CloseIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), size(ICON_SIZE + "px"), space, position, themeLeft);
CloseIcon.defaultProps = {
    name: 'close',
    mr: 'sp_4',
    position: 'absolute',
    themeLeft: 'sp_20',
};
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), space, height, boxSizing);
Content.defaultProps = {
    pt: ['54px', 'sp_64'],
    height: '100%',
    boxSizing: 'border-box',
};
var StyledRichTextBlock = styled(RichTextBlock)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  p {\n    ", ";\n  }\n"], ["\n  ", ";\n  p {\n    ", ";\n  }\n"])), space, fontSize);
StyledRichTextBlock.defaultProps = {
    p: ['sp_16', 'sp_24', null, 'sp_32'],
    fontSize: ['fs_14', null, 'fs_16', 'fs_18'],
};
var CommonDisclaimer = function () {
    var t = useLocalization().t;
    var closeDrawer = useCloseDrawer(EventBusEvent.ToggleDisclaimer);
    return (React.createElement(DisclaimerSubscription, null, function (_a) {
        var value = _a.value;
        var closeAction = value.closeAction, open = value.open, title = value.title, content = value.content, p = value.p, html = value.html;
        var onClose = closeAction || closeDrawer;
        return (React.createElement(SwipeListener, { onSwipeRight: onClose },
            React.createElement(Drawer, { isOpen: open, onBackdropClick: onClose },
                open && (React.createElement(Header, { onClick: onClose },
                    React.createElement(CloseIcon, null),
                    title === undefined ? t('h24_important_info') : title)),
                React.createElement(Content, null, content || (React.createElement(StyledRichTextBlock, { p: p, dangerouslySetInnerHTML: { __html: html }, "data-testid": "html" }))))));
    }));
};
export default CommonDisclaimer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
